import { render, staticRenderFns } from "./akm.vue?vue&type=template&id=7d5a48b0&scoped=true&"
import script from "./akm.vue?vue&type=script&lang=js&"
export * from "./akm.vue?vue&type=script&lang=js&"
import style0 from "./akm.vue?vue&type=style&index=0&id=7d5a48b0&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7d5a48b0",
  null
  
)

export default component.exports